import "./HamburgerMenu.scss";

import { useLayout } from "providers";

import { HeaderNavItem } from "./HeaderNavItem";

export const HamburgerMenu: React.FC = () => {
  const { isHamburgerOpen, navItems } = useLayout();

  if (!isHamburgerOpen) return null;

  return (
    <div className="sbb-hamburger-menu">
      <ul>
        {navItems.map((item, i) => {
          if (item.disabled) return null;

          return (
            <li key={`nav-item-sm-${i}`}>
              <HeaderNavItem className="sbb-header-hamburger-nav-item" item={item} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
